import * as React from "react";
import InputMask from "react-input-mask";
export interface ICustomInputProps {
  name: string;
  id: string;
  value: string;
  onChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeWithoutMask?: (value: string) => void;
}

export const CustomPhoneInput = (props: ICustomInputProps) => {
  const { id, name, value, onChange, onChangeWithoutMask } = props;
  return (
    <InputMask
      mask="(999) 999-9999"
      name={name}
      id={id}
      placeholder="(999) 999-9999"
      value={value}
      onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
        onChange(ev);
        const changedValue = ev.target.value
          .replace(/\)/g, "")
          .replace(/\(/g, "")
          .replace(/-/g, "")
          .replace(/ /g, "");
        onChangeWithoutMask && onChangeWithoutMask(changedValue);
      }}
    />
  );
};
export default CustomPhoneInput;
